/**
 * Definition for type of contacts for people
 */
export var PERSON_CONTACT_TYPE;
(function (PERSON_CONTACT_TYPE) {
  PERSON_CONTACT_TYPE[PERSON_CONTACT_TYPE["MAIN"] = 0] = "MAIN";
  PERSON_CONTACT_TYPE[PERSON_CONTACT_TYPE["STATUS"] = 1] = "STATUS";
  PERSON_CONTACT_TYPE[PERSON_CONTACT_TYPE["BILLING"] = 2] = "BILLING";
  PERSON_CONTACT_TYPE[PERSON_CONTACT_TYPE["SECONDARY"] = 3] = "SECONDARY";
})(PERSON_CONTACT_TYPE || (PERSON_CONTACT_TYPE = {}));